<template>
  <aside class="highlight-comment">
    <edi-comments-title :black-text="true">{{title}}</edi-comments-title>
    <div class="highlight-comment-item">
      <div class="wrapper">
        <div class="comment">
          <p class="text">
            <span class="num">
              #{{ num }}
            </span>
            {{ text }}
          </p>
          <div class="control-buttons" @mouseleave="showUserList = false">
            <div class="like-dislike">
              <edi-comment-valuation-btn
                @click="vote({ commentId, contentId })"
                @hover="checkUserLikes"
                :total="likes"
                :positive="true"
                :show-user-list="showUserList"
                :users="commentUserLikesList(commentId)"
                :active="isLikedComment(commentId)"
                :disabled="!isLogged || isOwnComment(userNick)"
              />
              <edi-comment-valuation-btn :total="dislikes" :positive="false" v-if="false"/>
            </div>
            <a
              v-if="true"
              class="open-comment"
              :href="url">
              Ir al comentario
              <i class="right-arrow fal fa-angle-right"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="author">
        <div class="author-info">
          <a @click.stop="showProfile" :href="userProfile(userProfileUrl)"
             class="author-name">
            {{authorName}}
              <div v-if="showLogginOptions" class="login-options">
                  <span>Solo los socios y socias pueden acceder a los perfiles.</span>
                  <a :href="loginUrl">Inicia Sesión</a> o <a :href="partnerUrl">Hazte Socio/a</a>
              </div>
          </a>
          <p class="publication-date">{{publicationDate|formatDate}}</p>
        </div>
        <a
          v-cursor
          @click.stop="showProfile" :href="userProfile(userProfileUrl)"
          class="author-img"
          :style="{ 'background-image' : `url(${authorAvatarUrl})` }"
        ></a>
      </div>
    </div>
  </aside>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import { PARTNER_COMMENT, DEFAULT_COMMENT, AUTHOR_COMMENT } from "../../api";

  import EdiCommentBadger from '../badger/EdiCommentBadger';
  import EdiCommentValuationBtn from '../btn/EdiCommentValuationBtn';
  import EdiCommentsTitle from '../EdiCommentsTitle';

  export default {
    name: 'edi-featured-comment',
    components: {
      EdiCommentsTitle,
      EdiCommentValuationBtn,
      EdiCommentBadger,
    },
    props: {
      comment: Object,
      contentId: Number,
    },
    data() {
      return {
        showOptions: false,
        showUserList: false,
        showLogginOptions: false,
      }
    },
    methods: {
      ...mapActions([
        'vote',
        'votes',
      ]),
      async checkUserLikes() {
        if (this.isLogged) {
          this.showUserList = true;
          await this.votes({ commentId: this.commentId, isPositive: true });
          // FIXME: esto debería funcionar igual que los usuarios silenciados,
          // por cuestiones de tiempo y wtf, he hecho esta ñapa, si ves esto
          // inténtalo hacer bien pls
          this.users = this.commentUserLikesList(this.commentId);
        }
      },
        showProfile() {
          if (!this.isLogged) {
              this.showLogginOptions = !this.showLogginOptions;
              setTimeout(this.closeOptions, 3000);
          } else {
              this.$emit('click');
          }
        },
        closeOptions() {
            this.showLogginOptions = false;
        }
    },
    computed: {
      ...mapGetters([
        'commentUserLikesList',
        'isLikedComment',
        'userProfile',
        'isLogged',
        'isOwnComment',
        'partnerUrl',
        'profileUrl',
        'loginUrl',
      ]),
      commentId() {
        return this.comment?.id;
      },
      text() {
        return this.comment?.text;
      },
      num() {
        return this.comment?.threadRelativeCommentId;
      },
      title() {
        return this.comment?.title || 'Destacado por infoLibre';
      },
      url() {
        return this.comment?.url;
      },
      authorName() {
        return this.comment?.user?.nick;
      },
      publicationDate() {
        // Esta patata la hacemos porque en el showroom el Datetime es serializado
        // a un objeto de js con estas propiedades, sin embargo cuando la respuesta
        // viene del Api dicha propiedad viene serializa como un string directamente
        const publicationDate = this.comment?.publicationDate?.date;
        return publicationDate ? publicationDate : this.comment?.publicationDate;
      },
      authorAvatarUrl() {
        return this.comment?.user?.avatarUr || '/assets/img/default-user-avatar.png';
      },
      isPartner() {
        return this.comment?.isPartner;
      },
      likes() {
        return this.comment?.numVotesPositive;
      },
      dislikes() {
        return this.comment?.numVotesNegative;
      },
      type() {
        if (this.isAuthorComment) {
          return AUTHOR_COMMENT;
        }
        if (this.isPartnerComment) {
          return PARTNER_COMMENT;
        }
        return DEFAULT_COMMENT;
      },
      partnerAge() {
        return this.comment?.user?.partnerAge;
      },
      isPartnerComment() {
        return this.comment?.user?.isPartner;
      },
      isAuthorComment() {
        return this.comment?.user?.isAuthor;
      },
      userProfileUrl(){
        return this.comment?.user?.profileUrl;
      }
    }
  }
</script>
